// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.create-games-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex:1 1;
  background-color: rgba(128, 128, 128, 0.075);
  border-radius: 1%;
}

.create-games-row-selector-container {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.create-games-topbar-container {
  display: flex;
  justify-content: space-between;

}

.create-games-topbar-back-button {
  background-color: bisque;
  padding: 10px;
  margin-left: 10px;
  margin-top: 10px;
  border-radius: 5px;
  border:1px;
  border-color: rgba(0, 0, 0, 0.226);
  border-style: solid;
  opacity: .8;
}

.create-games-topbar-continue-button {
  background-color: rgb(232, 255, 196);
  padding: 10px;
  margin-right: 10px;
  margin-top: 10px;
  border-radius: 5px;
  border:1px;
  border-color: rgba(0, 0, 0, 0.226);
  border-style: solid;
  opacity: .8;
}

.create-games-topbar-regenerate-button {
  background-color: rgb(254, 255, 196);
  padding: 10px;
  margin-right: 10px;
  margin-top: 10px;
  border-radius: 5px;
  border:1px;
  border-color: rgba(0, 0, 0, 0.226);
  border-style: solid;
  opacity: .8;
}

.create-games-topbar-back-button:hover {
  opacity: 1;
}

.create-games-topbar-back-button:active {
  font-weight: bold;
}
.create-games-container-exit-row-container {
  width: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
}

.create-games-screen-exit-button {
  padding:5px;
}

.choose-your-puzzle-directive-container {
  font-size: xx-large;
  margin-top: 20px;
  margin-bottom: 20px;
}`, "",{"version":3,"sources":["webpack://./src/Containers/Pages/Authenticated/CreateGames/CreateGames.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,QAAM;EACN,4CAA4C;EAC5C,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;;AAEhC;;AAEA;EACE,wBAAwB;EACxB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,kCAAkC;EAClC,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,kCAAkC;EAClC,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,kCAAkC;EAClC,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,aAAa;EACb,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":[".create-games-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  flex:1;\n  background-color: rgba(128, 128, 128, 0.075);\n  border-radius: 1%;\n}\n\n.create-games-row-selector-container {\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.create-games-topbar-container {\n  display: flex;\n  justify-content: space-between;\n\n}\n\n.create-games-topbar-back-button {\n  background-color: bisque;\n  padding: 10px;\n  margin-left: 10px;\n  margin-top: 10px;\n  border-radius: 5px;\n  border:1px;\n  border-color: rgba(0, 0, 0, 0.226);\n  border-style: solid;\n  opacity: .8;\n}\n\n.create-games-topbar-continue-button {\n  background-color: rgb(232, 255, 196);\n  padding: 10px;\n  margin-right: 10px;\n  margin-top: 10px;\n  border-radius: 5px;\n  border:1px;\n  border-color: rgba(0, 0, 0, 0.226);\n  border-style: solid;\n  opacity: .8;\n}\n\n.create-games-topbar-regenerate-button {\n  background-color: rgb(254, 255, 196);\n  padding: 10px;\n  margin-right: 10px;\n  margin-top: 10px;\n  border-radius: 5px;\n  border:1px;\n  border-color: rgba(0, 0, 0, 0.226);\n  border-style: solid;\n  opacity: .8;\n}\n\n.create-games-topbar-back-button:hover {\n  opacity: 1;\n}\n\n.create-games-topbar-back-button:active {\n  font-weight: bold;\n}\n.create-games-container-exit-row-container {\n  width: 100%;\n  display: flex;\n  align-items: flex-end;\n  justify-content: flex-end;\n}\n\n.create-games-screen-exit-button {\n  padding:5px;\n}\n\n.choose-your-puzzle-directive-container {\n  font-size: xx-large;\n  margin-top: 20px;\n  margin-bottom: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
